/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import { Link } from 'react-router-dom';

class TwitterOptions extends React.Component {
    render() {
        let currentPanel = null,
            postTitle = (parseInt(this.props.getParamValue('postTitle'), 10)) ? true : false,
            postBody = (parseInt(this.props.getParamValue('postBody'), 10)) ? true : false,
            postUrl = (parseInt(this.props.getParamValue('postUrl'), 10)) ? true : false,
            postImages = (parseInt(this.props.getParamValue('postImages'), 10)) ? true : false,
            prefixSpace = (parseInt(this.props.getParamValue('prefixSpace'), 10)) ? true : false,
            postfixSpace = (parseInt(this.props.getParamValue('postfixSpace'), 10)) ? true : false,
            postAsRetweet = (parseInt(this.props.getParamValue('postAsRetweet'), 10)) ? true : false,
            socialStats = (parseInt(this.props.getParamValue('socialStats'), 10)) ? true : false,
            statusLabel = this.props.getParamStateLabel('postAsRetweet'),
            controlState = this.props.getControlState();

        /*
        // removed postAsRetweet on 9/13/17 in response to abuse
        <fieldset>
            <legend>Post as Retweet{statusLabel}<HelpButton which="postAsRetweet"/></legend>
            <ErrorModule
                app={this.props.app}
                keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                render={(state) => {
                    return (
                        <FieldError field={this.props.errorMapping + '.postAsRetweet'} errors={state.errors}/>
                    );
                }}/>
            <Toggle
                active={postAsRetweet}
                noLabel={true}
                callback={this.props.changeHandler}
                linkedField={this.props.fieldMapping + ".postAsRetweet"}
                controlState={controlState} />
        </fieldset>
         */

        let visibleSettings = null;
        if (this.props.hasInputOverrides) {
            if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                visibleSettings = this.props.generateInputOverrideLink();
            } else {
                visibleSettings = (
                    <div>
                        {this.props.generateInputOverrideWarning()}
                        {this.props.getPostTitle(postTitle)}
                        {this.props.getPostBody(postBody)}
                        {this.props.getPostUrl(postUrl)}
                        {this.props.getPostPhoto(postImages)}
                    </div>
                )
            }
        } else {
            visibleSettings = (
                <div>
                    {this.props.getPostTitle(postTitle)}
                    {this.props.getPostBody(postBody)}
                    {this.props.getPostUrl(postUrl)}
                    {this.props.getPostPhoto(postImages)}
                </div>
            );
        }

        if (this.props.activePanel !== 'advanced') {
            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    {this.props.getSocialStats(socialStats)}
                    <fieldset>
                        <legend>Text Truncation Length</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="truncationLength" errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect options={[{value: 280, label: '280 characters - Default'}, {value: 140, label: '140 characters'}]}
                                      linkedField={this.props.fieldMapping + ".truncationLength"}
                                      onChange={this.props.changeHandler}
                                      value={this.props.getParamValue('truncationLength')}
                                      selectClass="large"
                                      controlState={controlState}/>
                    </fieldset>
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(TwitterOptions);
